// @flow
'use strict'

module.exports = function literal (pattern/*: string */)/*: string */ {
  return pattern
}
